import type { BaseListingEventPayload, CampaignAttribution } from './types';
import type { TrackingIdentity } from '~/composables/visitorIdentity';

import { getAdCampaignFromStorage } from '~/composables/adCampaign';
import { v4 as uuidv4 } from 'uuid';

function readClientFields(): BaseListingEventPayload['client'] {
	if (typeof window === 'undefined') {
		return {
			viewportWidth: 0,
			viewportHeight: 0,
			language: '',
			timezone: '',
			referrer: ''
		};
	}

	let timezone = '';
	try {
		timezone = Intl.DateTimeFormat().resolvedOptions().timeZone ?? '';
	} catch {
		/* some browsers throw under restricted intents — leave empty */
	}

	return {
		viewportWidth: window.innerWidth,
		viewportHeight: window.innerHeight,
		language: navigator.language || '',
		timezone,
		referrer: document.referrer || ''
	};
}

function readCampaignAttribution(): CampaignAttribution {
	const adCampaign = getAdCampaignFromStorage();
	if (Object.keys(adCampaign).length === 0) return {};
	return adCampaign as CampaignAttribution;
}

export function buildBaseListingEventPayload(
	identity: TrackingIdentity
): BaseListingEventPayload {
	return {
		eventId: uuidv4(),
		sessionId: identity.sessionId,
		userId: identity.userId,
		anonymousId: identity.anonymousId,
		client: readClientFields(),
		...readCampaignAttribution()
	};
}
